module.exports = __webpack_public_path__ + "fonts/baronsans-thinitalic-webfont.8595640b.woff2";